export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_UPPERCASE_REGEX = /[A-Z]/;
export const PASSWORD_LOWERCASE_REGEX = /[a-z]/;
export const PASSWORD_NUMBER_REGEX = /[0-9]/;
export const PASSWORD_SPECIAL_CHAR_REGEX = /[!@#$%^&*]/;

export interface PasswordRuleChecks {
  hasMinLength: boolean;
  hasUpperCase: boolean;
  hasLowerCase: boolean;
  hasNumber: boolean;
  hasSpecialChar: boolean;
  isValid: boolean;
}

export const getPasswordRuleChecks = (password: string): PasswordRuleChecks => {
  const value = password || "";
  const hasMinLength = value.length >= PASSWORD_MIN_LENGTH;
  const hasUpperCase = PASSWORD_UPPERCASE_REGEX.test(value);
  const hasLowerCase = PASSWORD_LOWERCASE_REGEX.test(value);
  const hasNumber = PASSWORD_NUMBER_REGEX.test(value);
  const hasSpecialChar = PASSWORD_SPECIAL_CHAR_REGEX.test(value);

  return {
    hasMinLength, hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar,
    isValid: hasMinLength && hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar,
  };
};
